import { app } from '../../../../../app';
import { Controller } from './remove-accounts.controller';

app.component('companyUserDirectoriesManageUserRemoveAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./remove-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/remove-accounts/remove-accounts.component.js